import styled from 'styled-components'

export const Table = styled.table`
  width: 90%;
  border: 1px;
  border-style: solid;
  margin-top: 5px;
`

export const THead = styled.thead`
  background-color: #DEDEDE;
`

export const Tr = styled.tr`
  border: 1px;
  border-style: solid;
`

export const Th = styled.th`
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  padding: 2px;
  color: '#000';
`

export const TBody = styled.tbody`
`

export const Td = styled.td`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 2px;
  color: '#000';
`
